import Vue from 'vue';
import Vuex from 'vuex';

// Additional dependencies
import axios from 'axios';
import Promise from 'bluebird';
import Cookies from 'js-cookie';
import crypto from 'crypto';
import jwtDecode from 'jwt-decode';
import moment from 'moment-timezone';
import functionCommon from './lib/functionCommon';
import authCommon from './lib/authCommon';
import storeConstruct from './store';
import router from './router';
import App from './App';
import vuetify from './plugins/vuetify';
import packageJson from '../package.json';
import udApi from './lib/udApi';
import userCommon from './lib/userCommon';
import validationCommon from './lib/validationCommon';

import AppButton from './components/AppButton';

require('./button.css');

// Additional dependency injections
const eventBus = new Vue();
const authCommonAdapter = new authCommon.Adapter({
  axios,
  Cookies,
  env,
  eventBus,
  jwtDecode,
  window
});
const udApiAdapter = new udApi.Adapter({
  authCommonAdapter,
  axios,
  env,
  Promise
});

const app = {
  authCommonAdapter,
  axios,
  crypto,
  env,
  eventBus,
  functionCommon,
  moment,
  packageJson,
  Promise,
  udApiAdapter,
  userCommon,
  validationCommon,
  window
};
Object.defineProperty(Vue.prototype, '$app', { value: app });

Vue.use(Vuex);

// Component injections
Vue.component('app-button', AppButton);

const vuexStore = new Vuex.Store(storeConstruct(app));

Vue.config.productionTip = false;

new Vue({
  render: (h) => h(App),
  router,
  store: vuexStore,
  vuetify
}).$mount('#app');
